import { defineComponent, inject, onMounted } from "vue";
import { showUIAndRestOfPage } from "@/shared-animations/hero";
import gsap from "gsap";
export default defineComponent({
  props: {
    title: { type: String, required: true },
    image: { type: String, required: false },
    date: { type: String, required: true },
    date2: { type: String, required: false },
    introduction: { type: String, required: false },
  },
  setup() {
    const emitter = inject("emitter");

    onMounted(() => {
      const heroTL = gsap.timeline({ delay: 0.75 });

      heroTL
        .add(function () {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore:next-line
          emitter.emit("pagewrapper-background-animation--stop", 3);
        })
        .addLabel("going-down-finished", "+=1")
        .from(
          ".hero__image",
          {
            yPercent: 100,
            duration: 1.6,
            ease: "power4.out",
          },
          "going-down-finished-=0.5"
        )
        .from(
          ".pagecontainer .hero .container, .pagecontainer section",
          {
            autoAlpha: 0,
            y: 200,
            duration: 1.6,
            ease: "power4.out",
          },
          "going-down-finished-=0.5"
        );
      heroTL.addLabel("showUI", "going-down-finished");
      showUIAndRestOfPage(heroTL);
    });
  },
});
